module.exports = __webpack_public_path__ + "img/mini-018.f3a27504.jpg";